import { render, staticRenderFns } from "./WorkGroupSingle.vue?vue&type=template&id=34d8992d"
import script from "./WorkGroupSingle.vue?vue&type=script&lang=js"
export * from "./WorkGroupSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports